Wee.fn.make('alertTop', {}, {
	_construct: function(conf) {
		this.conf = $.extend({
			selector: 'ref:weeTopAlert',
			cycleDelay: 4,
			cookieEnabled: false,
			daysToExpire: 7
		}, conf);

		this.$alert = $('ref:weeTopAlert');
		this.$sectionWrap = $('ref:weeTopAlertSections');
		this.sections = this.$alert.find('ref:weeTopAlertSection');
		this.disabled = '-disabled';

		this.init();
	},

	/**
     * Initialize alerts
     */
	init: function() {
		if (this.sections.length) {
			if (this.conf.cookieEnabled === true) {
				if (! Wee.cookie.get(this.$alert.data('id'))) {
					this.processAlert(this.$alert);
				}
			} else if (! this.alertsDisabled) {
				this.processAlert(this.$alert);
			}
		}
	},

	/**
     * Process individual alert
     *
     * @param $alert
     */
	processAlert: function($alert) {
		var sections = this.sections;

		if (sections.length > 1) {
			this.enableAlertCycle(sections);
		}

		this.bindEvents($alert);

		this.enableAlert($alert);
	},

	/**
     * Bind alert events
     *
     * @param $alert
     */
	bindEvents: function($alert) {
		var sections = this.sections,
			scope = this,
			close = 'ref:weeTopAlertSectionClose',
			i = 0;

		for (; i < sections.length; i++) {
			var $section = $(sections[i]);

			$section.find(close)
				.on('click.topAlert', function(e) {
					scope.disableAlert($alert, true);

					e.stopPropagation();
				});

			$('ref:weeTopAlertSection').on('click', function(e) {
				if (e.target === $(close)[0]) {
					e.preventDefault();

					e.stopPropagation();
				}

				scope.disableAlert($alert);
			});
		}
	},

	/**
     * Disable alert
     *
     * @param $alert
     */
	disableAlert: function($alert, disable) {
		var conf = this.conf;

		$alert.addClass(this.disabled);

		if (disable) {
			if (conf.cookieEnabled === true) {
				Wee.cookie.set($alert.data('id'), true);
			}

			this.alertsDisabled = true;

			Wee.events.off(false, '.topAlert');

			clearInterval(this.timer);

			if (this.conf.disabledCallback) {
				this.conf.disabledCallback();
			}
		}
	},

	/**
     * Enable alert
     *
     * @param $alert
     */
	enableAlert: function($alert) {
		var scope = this,
			delay = $alert.data('delay');

		if (delay) {
			window.setTimeout(function() {
				$alert.removeClass(scope.disabled);
			}, delay * 1000);
		} else {
			$alert.removeClass(scope.disabled);
		}

		if (this.conf.enabledCallback) {
			this.conf.enabledCallback();
		}
	},

	/**
     * If there exists more than one section in an alert, assume it needs to be
     * cycled.
     *
     * @param sections
     */
	enableAlertCycle: function(sections) {
		var $sectionWrap = this.$sectionWrap,
			height = $(sections).eq(0).height();

		this.timer = setInterval(function() {
			Wee.animate.tween('ref:weeTopAlertSections', {
				top: '-' + height
			}, {
				complete: function() {
					$sectionWrap.append($('ref:weeTopAlertSection').eq(0));
					$sectionWrap.css('top', '0px');
				}
			});
		}, this.conf.cycleDelay * 1000);

		// Force Chrome to repaint - revisit later
		$sectionWrap.children('ref:weeTopAlertSection')
			.css('transform', 'translateZ(1px)');
	}
}, {
	instance: false
});